import { useDispatch, useSelector } from "react-redux";
import { getSuccessMessage } from "./selectors";
import { addSuccessMessage, removeSuccessMessage } from "./actions";

export default function useSuccessMessage() {
	const dispatch = useDispatch();
	const success = useSelector(getSuccessMessage);

	const onAddSuccessMessage = (data) => {
		dispatch(addSuccessMessage(data));
	};

	const onRemoveSuccessMessage = () => {
		dispatch(removeSuccessMessage());
	};

	return {
		success,
		onAddSuccessMessage,
		onRemoveSuccessMessage,
	};
}
